import React from "react";
import ContentEditorComponent from "@components/ContentEditorView/ContentEditorComponent";

const RadioGroup = (props) => {
  const radioButtons = props.children.map((child) => {
    return {
      ...child,
      content: {
        ...child.content,
        name: props.name,
      },
    };
  });

  if (props.valid) {
    return (
      <div className="u-space-mb-5 u-space-mt-5">
        {props.label && (
          <label className="Form-label">
            {typeof props.label === "string" ? (
              <span
                dangerouslySetInnerHTML={{ __html: props.label }}
                className="inline-block"
              ></span>
            ) : (
              props.label
            )}
          </label>
        )}
        {radioButtons.map((radioButton, index) => (
          <ContentEditorComponent key={index} content={[radioButton]} />
        ))}
      </div>
    );
  }

  // Invalid component
  return null;
};

export default RadioGroup;
